/** Visual constants for `PromocodeRewardDialog`. */

export const PROMOCODE_REWARD_PRICE_TON_ICON_SIZE_PX = 24
